import React, { useState, useEffect, useRef } from 'react';
import { ArrowRight, Loader2, Lock, User, Info, FileText, PlayCircle, CalendarClock, ChevronDown, BookOpen, Settings, Megaphone, HelpCircle } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom'; 

const LoginPage = () => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [security,setSecurity] = useState({enabled:false,siteKey:null});
  const [challengeToken,setChallengeToken] = useState('');
  const widgetEl=useRef(null);
  useEffect(()=>{let mounted=true;fetch(`${process.env.REACT_APP_API_URL}/api/account/login-protection`).then(r=>r.json()).then(d=>{if(mounted)setSecurity(d)}).catch(()=>{});return()=>{mounted=false}},[]);
  useEffect(()=>{
    if(!security.enabled||!security.siteKey||!widgetEl.current)return;
    let mounted=true, widgetId=null;
    const render=()=>{if(!mounted||!widgetEl.current||!window.turnstile)return;widgetId=window.turnstile.render(widgetEl.current,{sitekey:security.siteKey,callback:t=>setChallengeToken(t),'expired-callback':()=>setChallengeToken(''),'error-callback':()=>setChallengeToken('')})};
    if(window.turnstile)render();else{
      const script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.async=true;script.defer=true;script.onload=render;document.head.appendChild(script);
    }
    return()=>{mounted=false;if(widgetId!==null&&window.turnstile)try{window.turnstile.remove(widgetId)}catch{}};
  },[security.enabled,security.siteKey]);
  const [error, setError] = useState('');
  
  const [activeTab, setActiveTab] = useState('pengumuman');
  const [openIndex, setOpenIndex] = useState(0); 

  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL; 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${BASE_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({...formData,turnstile_token:challengeToken}),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || 'Login gagal');
      }

      localStorage.setItem('token', data.token);
      localStorage.setItem('userName', data.user.name || data.user.username);
      localStorage.setItem('userRole', data.user.role);

      navigate('/dashboard');

    } catch (err) {
      alert(err.message); 
      setError(err.message);
      setChallengeToken('');
      if(window.turnstile)try{window.turnstile.reset()}catch{}
    } finally {
      setLoading(false);
    }
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const lastUpdated = "5 Mei 2026";
  
  const dataPengumuman = [
    {
      icon: <Info className="w-5 h-5 text-blue-400" />,
      title: "Informasi PAK Integrasi",
      content: "Bagi Bapak/Ibu guru yang belum menerima PAK INTEGRASI, dapat mengecek dan mengunduh dokumen melalui tautan di bawah.",
      note: "Bagi yang sudah menerima PAK Integrasi dapat mengabaikan pesan ini.",
      link: "https://drive.google.com/drive/folders/1Rn0rjQsoUvu53An5TtH_soV9kvemrlxL?usp=sharing",
      linkText: "Buka Google Drive"
    },
    {
      icon: <FileText className="w-5 h-5 text-amber-400" />,
      title: "Materi Sosialisasi Kenaikan Pangkat",
      content: "Materi Sosialisasi Kenaikan Pangkat tahun 2026 sudah dapat diunduh dan dipelajari oleh seluruh pegawai.",
      note: "Silakan klik tombol di bawah untuk mengakses materi lengkap.",
      link: "http://bit.ly/4doSsCN",
      linkText: "Unduh Materi Sosialisasi"
    },
    {
      icon: <PlayCircle className="w-5 h-5 text-emerald-400" />,
      title: "Panduan Penggunaan SIPAK",
      content: "Untuk menghindari kesalahan pengisian data, Bapak/Ibu dihimbau untuk menyaksikan video tutorial penggunaan aplikasi SIPAK terlebih dahulu.",
      note: "Klik tombol di bawah untuk menonton video panduan.",
      link: "https://youtu.be/YwQYZCV1uZQ", 
      linkText: "Tonton Tutorial"
    }
  ];

  // --- DATA FAQ UMUM ---
  const dataFaqUmum = [
    {
      title: "1. Apa perbedaan antara PAK Konvensional, PAK Integrasi, dan PAK Konversi?",
      content: "PAK Konvensional: Sistem penilaian angka kredit berdasarkan butir kegiatan (Karya Ilmiah, Pengembangan Diri, dsb). Berlaku hingga 31 Desember 2022.\n\nPAK Integrasi: Dokumen transisi untuk menyesuaikan angka kredit dari format Konvensional ke format Konversi sesuai Peraturan BKN Nomor 3 Tahun 2023.\n\nPAK Konversi: Sistem penilaian angka kredit berdasarkan konversi Predikat Kinerja (SKP). Berlaku mulai 1 Januari 2023 hingga saat ini."
    },
    {
      title: "2. Apakah saya bisa langsung mengajukan PAK Konversi?",
      content: "Belum bisa: Jika PAK terakhir Anda masih dalam format Konvensional. Anda wajib mengurus PAK Integrasi terlebih dahulu.\n\nBisa: Jika PAK terakhir Anda sudah dalam format Integrasi atau sudah pernah memiliki PAK Konversi dengan format terbaru."
    },
    {
      title: "3. Bagaimana prosedur pengurusan PAK Integrasi?",
      content: "Pengurusan disesuaikan dengan pangkat dan golongan Anda:\n\n• Golongan IV/a ke bawah: Melalui aplikasi KIERUN.\n• Golongan IV/b ke atas: Melalui aplikasi SIMPAKIN."
    },
    {
      title: "4. Bagaimana cara mengurus PAK Konversi di lingkungan Sudindik JT2?",
      content: "Untuk seluruh jabatan fungsional (semua golongan) di lingkungan Sudindik JT2 menggunakan aplikasi SIPAK melalui tautan: https://sipak.sudindikjt2.site/"
    },
    {
      title: "5. Bagaimana jika saya lupa password akun aplikasi KIERUN?",
      content: "Bagi Bapak/Ibu yang lupa password pada aplikasi KIERUN, saat ini seluruh akun KIERUN telah di-reset secara massal. Silakan Bapak/Ibu coba login kembali menggunakan password default yaitu: admin"
    },
    {
      title: "6. Bagaimana cara mengikuti Uji Kompetensi Kenaikan Jenjang (UKKJ)?",
      content: "Pendaftaran dan pelaksanaan UKKJ dapat diakses melalui akun SIMPKB masing-masing pegawai."
    },
    {
      title: "7. Apa langkah selanjutnya untuk mengusulkan Kenaikan Jenjang Jabatan Fungsional?",
      content: "Usulan dilakukan melalui aplikasi KIERUN setelah Anda dinyatakan LULUS dalam UKKJ."
    },
    {
      title: "8. Bagaimana prosedur pengusulan Kenaikan Pangkat di Sudindik JT2?",
      content: "Pengusulan Kenaikan Pangkat dilakukan melalui menu SIPAK saat periode dibuka: periksa data, isi riwayat PAK, unggah persyaratan, kirim usulan. Satlak memeriksa terlebih dahulu, lalu Sudin. Lihat menu Panduan Usulan KP untuk petunjuk sederhana."
    },
    {
      title: "9. Bagaimana cara mengusulkan Pencantuman Gelar (Ijazah Baru)?",
      content: "Pengajuan usul pencantuman gelar baru harus berjenjang dari Satlak Kecamatan, yang nantinya akan diteruskan ke Suban Kepegawaian Kota.\n\nPastikan Bapak/Ibu sudah memiliki Surat Izin Belajar yang diterbitkan oleh Kepala Dinas Pendidikan. Nanti, jika data ijazah tersebut sudah resmi berubah/masuk di aplikasi MyASN BKN, barulah data ijazah tersebut bisa diinput ke aplikasi SIPAK untuk dihitung sebagai penambahan angka kredit."
    },
    {
      title: "10. Kenapa PAK Integrasi saya belum terbit, padahal teman seangkatan Jafung sudah dapat?",
      content: "Bagi Bapak/Ibu guru pengangkatan pertama (Ahli Pertama) yang belum mendapatkan PAK Integrasi, mohon bersabar. Saat ini dokumen tersebut masih dalam proses perbaikan/koreksi."
    },
    {
      title: "11. Kapan jadwal penyerahan berkas Kenaikan Pangkat ke Kecamatan?",
      content: "Sesuai aturan BKN yang baru, periode Kenaikan Pangkat sekarang ditetapkan setiap bulan (tanggal 1 Januari s.d. 1 Desember).\n\nUntuk jadwal pengusulannya, berkas dari Sekolah harus sudah diserahkan ke Satlak Kecamatan pada tanggal 1 s.d. 10. Jarak penyerahan ini adalah 2 bulan sebelum bulan Kenaikan Pangkat yang Bapak/Ibu tuju.\n\nContoh: Jika Bapak/Ibu ingin naik pangkat TMT 1 Januari, maka berkas harus diserahkan ke Satlak pada rentang tanggal 1 s.d. 10 November. Usulan yang melampaui tanggal tersebut atau berkasnya tidak lengkap, otomatis tidak akan diproses."
    },
    {
      title: "12. Berkas apa saja yang harus disiapkan ke Satlak setelah PAK Konversi ini selesai?",
      content: "Setelah usulan PAK Konversi dari aplikasi SIPAK ini terbit, silakan siapkan dokumen berikut (semua dokumen merupakan hasil Scan ASLI, berwarna, format PDF maksimal 900 KB per file):\n\nPersyaratan Usul Kenaikan Pangkat Jabatan Fungsional:\n1. SK Kenaikan Pangkat Terakhir\n2. SK CPNS dan SK PNS\n3. SK Jabatan Fungsional Asli (Lampirkan Berita Acara Pelantikan jika baru diangkat/naik jenjang)\n4. PAK Terakhir Asli & Riwayat PAK sebelumnya (yang sudah dilegalisir)\n5. Sertifikat Pendidik (Serdik)\n6. Sertifikat Uji Kompetensi / UKKJ (khusus bagi JF yang naik jenjang)\n7. SKP 2 Tahun Terakhir (minimal bernilai Baik/sesuai ekspektasi)\n\nKhusus Usul Kenaikan Pangkat Penyesuaian Ijazah (PI), tambahkan berkas kelulusan asli berupa: Ijazah, Transkrip Nilai, Bukti Forlap Dikti, Akreditasi Prodi (saat lulus), Surat Izin Belajar, dan STLUKP."
    }
  ];

  // --- DATA FAQ TEKNIS ---
  const dataFaqTeknis = [
    {
      title: "1. Pada menu Profil, jenis PAK apa yang harus saya pilih jika saya memiliki PAK Integrasi dan PAK Konversi?",
      content: "Jika Anda mempunyai kedua jenis PAK tersebut, silakan pilih opsi PAK KONVERSI."
    },
    {
      title: "2. Saya memiliki ijazah pendidikan yang lebih tinggi, bolehkah saya menginputnya di formulir SIPAK?",
      content: "Data ijazah baru hanya boleh diinput setelah proses Pencantuman Gelar selesai dan riwayat pendidikan tersebut sudah tercatat secara resmi di aplikasi MyASN."
    },
    {
      title: "3. Masa kerja manakah yang harus diisi pada menu Profil Pegawai?",
      content: "Isilah masa kerja sesuai dengan yang tertera pada SK Kenaikan Pangkat Terakhir."
    },
    {
      title: "4. Di mana saya bisa melihat 'Periode Penilaian' untuk diinput ke SIPAK?",
      content: "Periode penilaian dapat dilihat pada dokumen PAK Integrasi atau PAK Konversi terakhir Anda. Informasi tersebut biasanya terletak pada bagian kanan atas dokumen PAK."
    },
    {
      title: "5. Mengapa saya selalu gagal saat mengunggah (upload) berkas?",
      content: "Pastikan dokumen memenuhi kriteria berikut:\n• Format file: PDF.\n• Ukuran maksimal: 900 KB per file."
    },
    {
      title: "6. Apakah saya wajib mengunggah seluruh dokumen yang diminta?",
      content: "Anda wajib mengunggah seluruh Dokumen Wajib. Dokumen pendukung lainnya sangat disarankan untuk diunggah sebagai pelengkap verifikasi."
    },
    {
      title: "7. Bagaimana jika saya sudah mengirim usulan (submit), namun terdapat data yang salah?",
      content: "Usulan yang sudah dikirim tidak dapat diubah kembali. Silakan tunggu proses verifikasi dari petugas. Jika terdapat kesalahan data, petugas akan memberikan status \"Ditolak\", dan Anda dapat melakukan perbaikan kemudian mengirim ulang usulan tersebut."
    },
    {
      title: "8. Bagi lulusan PPJG 2024/2025, jenis PAK apa yang harus dipilih (Integrasi atau Konversi)?",
      content: "Silakan perhatikan jumlah Angka Kredit pada dokumen Bapak/Ibu:\n\n• Jika Angka Kreditnya tertera tepat 48,96 maka di aplikasi silakan pilih opsi PAK INTEGRASI.\n• Namun, jika Angka Kreditnya SELAIN angka 48,96 maka silakan pilih opsi PAK KONVERSI."
    },
    {
      title: "9. Saya naik golongan sebelum tahun 2019 dan tidak punya SK Jafung. Di kolom upload SK Jafung, saya harus unggah berkas apa?",
      content: "Bagi Bapak/Ibu yang naik ke golongan sebelum tahun 2019, memang belum diterbitkan SK Jabatan Fungsional (Jafung) tersendiri.\n\nSebagai gantinya, silakan unggah SK Pangkat Golongan Terakhir Bapak/Ibu pada kolom upload SK Jafung tersebut. Jika memungkinkan, boleh juga ditambahkan sedikit catatan/keterangan agar tim verifikator lebih mudah saat melakukan pengecekan."
    }
  ];

  const renderList = (dataList) => {
    return dataList.map((item, index) => {
      const isOpen = openIndex === index;
      return (
        <div key={index} className={`mb-3 border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'bg-slate-800/80 border-amber-500/50' : 'bg-slate-800/30 border-slate-700/50 hover:border-slate-600'}`}>
          <button onClick={() => toggleAccordion(index)} className="w-full p-4 flex items-start text-left focus:outline-none">
            {item.icon && <div className="mt-0.5 mr-3 shrink-0">{item.icon}</div>}
            {!item.icon && <HelpCircle className="w-5 h-5 text-slate-500 mt-0.5 mr-3 shrink-0" />}
            
            <span className={`font-semibold text-sm flex-1 pr-4 leading-snug ${isOpen ? 'text-amber-400' : 'text-slate-200'}`}>
              {item.title}
            </span>
            
            <ChevronDown className={`shrink-0 w-5 h-5 transform transition-transform duration-300 ${isOpen ? 'rotate-180 text-amber-400' : 'text-slate-500'}`} />
          </button>
          
          <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'}`}>
            <div className="p-4 pt-0 pl-12 text-slate-300 text-sm leading-relaxed whitespace-pre-line break-words">
              {item.content}
              
              {item.note && (
                <div className="mt-2 text-xs text-amber-500/80 italic">* {item.note}</div>
              )}
              
              {item.link && (
                <a href={item.link} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold px-4 py-2 rounded-lg transition-colors w-max shadow-md shadow-blue-900/50">
                  {item.linkText} <ArrowRight className="w-3.5 h-3.5" />
                </a>
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="min-h-screen flex flex-col-reverse lg:flex-row font-sans text-slate-800 bg-white overflow-x-hidden">
      
      {/* ============================================== */}
      {/* BAGIAN KIRI: PUSAT INFORMASI & FAQ (60%) */}
      {/* ============================================== */}
      <div className="w-full lg:w-[60%] lg:h-screen lg:overflow-y-auto overflow-x-hidden relative bg-slate-900 p-6 md:p-12 text-white custom-scrollbar">
        
        {/* Dekorasi Background */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600 rounded-full blur-[120px] opacity-20 translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-500 rounded-full blur-[100px] opacity-10 -translate-x-1/3 translate-y-1/3 pointer-events-none"></div>

        <div className="relative z-10 max-w-2xl mx-auto lg:ml-auto lg:mr-8 pt-8 lg:pt-0">
          
          <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-2 font-serif text-center lg:text-left">SIPAK</h1>
          <h3 className="text-xl md:text-3xl font-semibold leading-snug mb-6 font-serif text-center lg:text-left">
            Sistem <br className="hidden lg:block"/>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500">
              Penetapan Angka Kredit
            </span>
          </h3>
          <p className="text-sm md:text-base text-slate-400 border-l-2 border-amber-500 pl-4 mb-8 leading-relaxed mx-auto lg:mx-0 max-w-md">
            Suku Dinas Pendidikan Wilayah II <br/> Kota Administrasi Jakarta Timur.
          </p>

          <div className="flex flex-wrap gap-2 mb-6 border-b border-slate-700/50 pb-4 justify-center lg:justify-start">
            <button 
              onClick={() => { setActiveTab('pengumuman'); setOpenIndex(0); }}
              className={`px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition-all ${activeTab === 'pengumuman' ? 'bg-amber-500 text-slate-900 shadow-lg' : 'bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-slate-200'}`}
            >
              <Megaphone size={16}/> Pengumuman
            </button>
            <button 
              onClick={() => { setActiveTab('faq_umum'); setOpenIndex(0); }}
              className={`px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition-all ${activeTab === 'faq_umum' ? 'bg-amber-500 text-slate-900 shadow-lg' : 'bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-slate-200'}`}
            >
              <BookOpen size={16}/> FAQ Umum
            </button>
            <button 
              onClick={() => { setActiveTab('faq_teknis'); setOpenIndex(0); }}
              className={`px-4 py-2 rounded-lg text-sm font-bold flex items-center gap-2 transition-all ${activeTab === 'faq_teknis' ? 'bg-amber-500 text-slate-900 shadow-lg' : 'bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-slate-200'}`}
            >
              <Settings size={16}/> FAQ Teknis
            </button>
          </div>

          <div className="flex justify-between items-center mb-4">
             <h4 className="text-xs font-bold text-slate-400 uppercase tracking-wider">
               {activeTab === 'pengumuman' ? 'Informasi Terbaru' : 'Pusat Bantuan & Tanya Jawab'}
             </h4>
             {activeTab === 'pengumuman' && (
               <div className="flex items-center gap-1.5 text-[10px] text-slate-500">
                 <CalendarClock className="w-3 h-3" /> Diperbarui: {lastUpdated}
               </div>
             )}
          </div>

          <div className="pb-12">
            {activeTab === 'pengumuman' && renderList(dataPengumuman)}
            {activeTab === 'faq_umum' && renderList(dataFaqUmum)}
            {activeTab === 'faq_teknis' && renderList(dataFaqTeknis)}
          </div>

        </div>
      </div>

      {/* ============================================== */}
      {/* BAGIAN KANAN: FORM LOGIN (40%) */}
      {/* ============================================== */}
      <div className="w-full lg:w-[40%] bg-white flex flex-col justify-center p-8 md:p-16 lg:h-screen lg:sticky top-0 border-b lg:border-b-0 lg:border-l border-slate-200 z-20 shadow-2xl">
        <div className="max-w-sm w-full mx-auto">
            
            <div className="lg:hidden flex justify-center mb-6">
               <img src="/logo-dki.png" alt="Logo DKI" className="w-20 h-20 object-contain" />
            </div>

            <div className="mb-10 text-center lg:text-left">
                <h2 className="text-3xl font-bold text-slate-900 mb-2 font-serif">Selamat Datang</h2>
                <p className="text-slate-500 text-sm">Silakan masuk dengan NIP dan Kata Sandi Anda.</p>
            </div>

            {error && (
               <div className="mb-6 p-3 bg-red-50 text-red-600 text-xs font-bold rounded-lg border border-red-200 text-center">
                  {error}
               </div>
            )}

            <form onSubmit={handleLogin} className="space-y-6">
                <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-2 tracking-wider">Username / NIP</label>
                    <div className="relative group">
                        <div className="absolute inset-y-0 left-0 pl-0 flex items-center pointer-events-none">
                            <User className="h-5 w-5 text-slate-400 group-focus-within:text-amber-600 transition-colors" />
                        </div>
                        <input 
                            type="text" 
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            className="block w-full pl-8 pr-3 py-3 border-b-2 border-slate-200 bg-transparent text-slate-900 placeholder-slate-300 focus:border-amber-600 focus:outline-none transition-colors font-medium" 
                            placeholder="Masukkan NIP"
                            required
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-2 tracking-wider">Password</label>
                    <div className="relative group">
                        <div className="absolute inset-y-0 left-0 pl-0 flex items-center pointer-events-none">
                            <Lock className="h-5 w-5 text-slate-400 group-focus-within:text-amber-600 transition-colors" />
                        </div>
                        <input 
                            type="password" 
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="block w-full pl-8 pr-3 py-3 border-b-2 border-slate-200 bg-transparent text-slate-900 placeholder-slate-300 focus:border-amber-600 focus:outline-none transition-colors font-medium" 
                            placeholder="••••••••"
                            required
                        />
                    </div>
                </div>

                <button 
                    type="submit" 
                    disabled={loading || (security.enabled && !challengeToken)}
                    className="w-full bg-slate-900 text-white h-14 mt-8 flex items-center justify-between px-6 hover:bg-slate-800 rounded-xl transition-all duration-300 group disabled:bg-slate-400 shadow-xl shadow-slate-900/20"
                >
                    <span className="font-bold tracking-wide text-sm md:text-base">
                        {loading ? 'MEMPROSES...' : 'MASUK APLIKASI'}
                    </span>
                    {loading ? (
                        <Loader2 className="w-5 h-5 animate-spin" />
                    ) : (
                        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    )}
                </button>
              {security.enabled && <div className="mt-4"><div ref={widgetEl}/><p className="text-xs text-slate-500 mt-2">Pemeriksaan keamanan sebelum masuk.</p></div>}
            </form>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-base">
              <Link className="text-blue-700 font-bold underline" to="/lupa-password">Lupa Password?</Link>
              <Link className="text-blue-700 font-bold underline" to="/panduan-kenaikan-pangkat">Cara Usul Kenaikan Pangkat</Link>
            </div>
        </div>
      </div>

    </div>
  );
};

export default LoginPage;